import { PublicClientApplication } from "@azure/msal-browser";
import { internalAuthConfig } from "./authConfig";

export const internalMsal = new PublicClientApplication(internalAuthConfig);